// NATIVE

// INSTALLED
import { Dispatch } from 'redux';
import { getDataFormInputsServiceCompany } from '../../services';
import { checkingPreload, unCheckingPreload } from '../loading';
import { setDepartamentsByIdRedux, setDepartamentsRedux } from './departamentSlice';
import { setDepartamentsByIdService } from '../../services/departament.service';

// CUSTOM

export const setDepartamentByCountryId = (departament_id: string): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    const response = await setDepartamentsByIdService(departament_id);

    if (response.ok) {
      dispatch(setDepartamentsRedux(response.data));
    } else {
    }

    dispatch(unCheckingPreload());
    return response;
  };
};

export const setMunicipalyByDepartament = (departament_id: string): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    dispatch(setDepartamentsByIdRedux(departament_id));

    dispatch(unCheckingPreload());
  };
};

// export const setDepartaments = (departaments: object[]): any => {

//     return async( dispatch: any ) => {

//         dispatch( checkingPreload() );

//           dispatch( setDepartamentsRedux(departaments) )

//         dispatch( unCheckingPreload() );

//     }
// }
